export default __webpack_public_path__ + "7f19c13fc8dcc0d995740a3b16215314.png";